import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { MessageContentUnion } from '@airgram/core/types/outputs';
import { MessageAudio } from '@airgram/core/types/outputs/MessageContent';
import { FilePart } from '@airgram/web';
import { FileReaderService } from '@src/core/services';
import { MultimediaSource } from '@src/models';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'app-message-audio',
  templateUrl: './message-audio.component.html',
  styleUrls: ['../styles/message-content.scss', './message-audio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageAudioComponent extends BaseResizableComponent {
  private readonly fileReaderService = inject(FileReaderService);

  @Input() set message(mess: MessageContentUnion | undefined) {
    this.messageAudio = mess as MessageAudio;
  }

  messageAudio?: MessageAudio;
  messageAudioSource?: MultimediaSource;

  override ngOnInit(): void {
    super.ngOnInit();

    this.initAudio();
  }

  private initAudio(): void {
    if (!this.messageAudio) return;

    this.fileReaderService
      .getFilePart(this.messageAudio?.audio?.audio)
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(filePart => this.setAudioSource(filePart));
  }

  private setAudioSource(filePart?: FilePart): void {
    this.messageAudioSource = { src: this.fileReaderService.getFileSource(filePart) };
    this.cdr.markForCheck();
  }
}
